import { Actions } from "../actions";
import { AppointmentObject } from ".";

// Update log
// FB  6192   02/06/2023  DK  Reducer for the state management

export default function reducer(state: AppointmentObject, action: Actions) {
  switch (action.type) {
    case "MODIFY_APPOINTMENT_OBJECT":
      return { ...state, AppointmentObject: action.data };

    case "MODIFY_SLOT_DETAILS":
      return { ...state, slotDetails: action.data };

    default:
      return state;
  }
}
